"use strict";

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _prism = _interopRequireDefault(require("react-syntax-highlighter/prism"));

var React = _interopRequireWildcard(require("react"));

var _prism2 = require("react-syntax-highlighter/styles/prism");

var Highlighter = function Highlighter(props) {
  var language = props.language;

  if (language === "ipython") {
    language = "python";
  } else if (language === "text/x-scala") {
    // Adjust for the scala codemirror type
    language = "scala";
  } else if (language.startsWith("text/x-")) {
    // Strip off the language from the mimetype
    language = language.slice("text/x-".length);
  }

  return React.createElement(_prism["default"], {
    style: props.theme === "light" ? _prism2.vs : _prism2.xonokai,
    language: language,
    className: props.className,
    customStyle: {
      padding: "10px 0px 10px 10px",
      margin: "0px",
      backgroundColor: "var(--cm-background, #fafafa)",
      border: "none"
    }
  }, props.children);
};

Highlighter.defaultProps = {
  theme: "light",
  language: "text",
  children: "",
  className: "input"
};
var _default = Highlighter;
exports["default"] = _default;